import type {
  LuggageOption,
  LuggageTypes,
} from '@lt/api/dist/methods/packages/types';
import { DTOError } from 'src/error/errors/DTOError';

export const luggageDTO = (data: unknown): LuggageTypes => {
  if (
    data &&
    typeof data === 'object' &&
    'comment' in data &&
    'hand' in data &&
    'hold' in data
  ) {
    return {
      comment: typeof data.comment === 'string' ? data.comment : '',
      hand: luggageOptionDTO(data.hand),
      hold: luggageOptionDTO(data.hold),
      ski_equipment:
        'ski_equipment' in data
          ? luggageOptionDTO(data.ski_equipment)
          : undefined,
    };
  }

  throw new DTOError('luggageDTO', data);
};

const luggageOptionDTO = (data: unknown): LuggageOption => {
  if (data && typeof data === 'object' && 'count' in data && 'weight' in data) {
    return {
      count: typeof data.count === 'number' ? data.count : undefined,
      size: 'size' in data ? luggageSizeDTO(data.size) : undefined,
      weight: typeof data.weight === 'number' ? data.weight : undefined,
      transportation_type:
        'transportation_type' in data &&
        (data.transportation_type === 'without_equipment' ||
          data.transportation_type === 'with_baggage' ||
          data.transportation_type === 'additional_space')
          ? data.transportation_type
          : undefined,
    };
  }

  return {};
};

const luggageSizeDTO = (data: unknown): number[] => {
  if (data && Array.isArray(data)) {
    return data.map((size) => (typeof size === 'number' ? size : 0));
  }

  return [];
};
